<template>
	<RouterView />
	<Loader />
	<DynamicDialog />
</template>

<script lang="ts">
import { defineComponent, nextTick, onBeforeMount, onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useConfigStore } from '@/stores/config';
import { useThemeStore } from '@/stores/theme';
import { useBodyStore } from '@/stores/body';
// import SwalManager from './core/helpers/SwalManager';
import { themeConfigValue } from '@/layouts/default-layout/config/helper';
import { initializeComponents } from '@/core/plugins/keenthemes';
import Loader from './components/Loader.vue';
// import { useAuthStore } from './stores/auth';
import DynamicDialog from 'primevue/dynamicdialog';

export default defineComponent({
	name: 'app',
	components: {
		RouterView,
		Loader,
		DynamicDialog,
	},
	setup() {
		const configStore = useConfigStore();
		const themeStore = useThemeStore();
		const bodyStore = useBodyStore();
		// const router = useRouter();
		// const store = useAuthStore();
		// // this timer responsible for showing alert to continue
		// const alertTimeout = ref<number | null>(null);
		// const alertTime = 1500000; // 25 mins

		// // this timer responsible for navigate user to login screen
		// const loginTimeout = ref<number | null>(null);
		// const loginTime = 1800000; // 30 mins

		// // this check if any popop dialog open to prevent overlap
		// const alertShown = ref(false);

		// // this const holds all the pages where the alert should not appear
		// const publicPages = ref([
		// 	'sign-in',
		// 	'password-reset',
		// 	'ChangeDefaultPassword',
		// 	'ChangeForgotPassword',
		// ] as string[]);

		// const handleUserActivity = () => {
		// 	// Reset the timer when there is user interaction
		// 	clearInterval(alertTimeout.value!);
		// 	clearInterval(loginTimeout.value!);

		// 	alertTimeout.value = setInterval(() => {
		// 		showAlertDialog();
		// 	}, alertTime);

		// 	loginTimeout.value = setInterval(() => {
		// 		reLogin();
		// 	}, loginTime);
		// };

		// const reLogin = () => {
		// 	if (
		// 		!publicPages.value.includes(router.currentRoute.value.name as string)
		// 	) {
		// 		{
		// 			store.purgeAuth();
		// 			router.push({ name: 'sign-in' });
		// 			location.reload();
		// 		}
		// 	}
		// };

		// const showAlertDialog = () => {
		// 	// Show the alert only if another alert is not currently displayed
		// 	if (
		// 		!alertShown.value &&
		// 		!publicPages.value.includes(router.currentRoute.value.name as string)
		// 	) {
		// 		alertShown.value = true;

		// 		// You can customize this method to show your alert dialog
		// 		SwalManager.info('Are you want to continue?').then(() => {
		// 			// Reset the flag after the alert is closed
		// 			setTimeout(() => {
		// 				alertShown.value = false;
		// 			}, alertTime); // Adjust the timeout based on your needs
		// 		});
		// 	}
		// };

		onBeforeMount(() => {
			/**
			 * Overrides the layout config using saved data from localStorage
			 * remove this to use static config (@/layouts/default-layout/config/DefaultLayoutConfig.ts)
			 */
			configStore.overrideLayoutConfig();

			// Remove event listeners and clear the timer to prevent memory leaks
			// document.removeEventListener('mousemove', handleUserActivity);
			// document.removeEventListener('keydown', handleUserActivity);
			// document.removeEventListener('mousedown', handleUserActivity);
			// document.removeEventListener('touchstart', handleUserActivity);

			/**
			 *  Sets a mode from configuration
			 */
			themeStore.setThemeMode(themeConfigValue.value);
		});

		onMounted(() => {
			nextTick(() => {
				initializeComponents();

				// Add event listeners to detect user interactions
				// document.addEventListener('mousemove', handleUserActivity);
				// document.addEventListener('keydown', handleUserActivity);
				// document.addEventListener('mousedown', handleUserActivity);
				// document.addEventListener('touchstart', handleUserActivity);

				bodyStore.removeBodyClassName('page-loading');
			});
		});
	},
});
</script>

<style lang="scss">
@import 'bootstrap-icons/font/bootstrap-icons.css';
@import 'apexcharts/dist/apexcharts.css';
@import 'quill/dist/quill.snow.css';
@import 'animate.css';
@import 'sweetalert2/dist/sweetalert2.css';
@import 'nouislider/dist/nouislider.css';
@import '@fortawesome/fontawesome-free/css/all.min.css';
@import 'socicon/css/socicon.css';
@import 'line-awesome/dist/line-awesome/css/line-awesome.css';
@import 'dropzone/dist/dropzone.css';
@import '@vueform/multiselect/themes/default.css';
@import 'prism-themes/themes/prism-shades-of-purple.css';
@import 'element-plus/dist/index.css';

// Main demo style scss
@import 'assets/keenicons/duotone/style.css';
@import 'assets/keenicons/outline/style.css';
@import 'assets/keenicons/solid/style.css';
@import 'assets/sass/element-ui.dark';
@import 'assets/sass/plugins';
@import 'assets/sass/style';

#app {
	display: contents;
}
</style>
